var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/components/Choices.jsx
var import_react = __toESM(require("react"));
var import_prop_types = __toESM(require("prop-types"));
var import_dequal = require("dequal");
function Choices(props2) {
  const [availableChoices, setAvailableChoices] = (0, import_react.useState)(props2.choices.filter(Boolean) || []);
  const [choicesObj, setChoicesObj] = (0, import_react.useState)(null);
  const [selectElement, setSelectElement] = (0, import_react.useState)();
  const [selected, setSelected] = (0, import_react.useState)();
  const inputEl = (0, import_react.useRef)();
  const allowRemove = props2.allowRemove == void 0 ? props2.selectMultiple : props2.allowRemove;
  const containerClassName = `select custom-select form-control form-control-sm ${props2.className || ""}`;
  const onChange = function(event) {
    let chosen = this.getValue(true);
    if (Array.isArray(chosen)) {
      chosen = chosen.map((choice) => this._q_items.get(choice));
    } else if (void 0 == chosen) {
      chosen = null;
    } else {
      chosen = this._q_items.get(chosen);
    }
    setSelected(chosen);
    if (props2.onChange) {
      props2.onChange(chosen);
    }
  };
  (0, import_react.useEffect)(() => {
    if (!choicesObj && selectElement) {
      if (selectElement.dataset["choice"] != "active") {
        const ChoicesJs = require("choices.js");
        const choices = new ChoicesJs(
          selectElement,
          {
            classNames: {
              containerInner: containerClassName,
              input: "form-control",
              inputCloned: "form-control-sm",
              listDropdown: "dropdown-menu",
              itemChoice: "dropdown-item",
              activeState: "show",
              selectedState: "active"
            },
            shouldSort: false,
            removeItemButton: allowRemove
          }
        );
        selectElement.addEventListener("change", onChange.bind(choices));
        setChoicesObj(choices);
        return () => {
          selectElement?.removeEventListener("change", onChange);
        };
      }
    }
  }, [selectElement, setChoicesObj]);
  (0, import_react.useEffect)(() => {
    if (inputEl.current && !inputEl.current.hasChildNodes()) {
      const selectElement2 = document.createElement("select");
      selectElement2.name = props2.inputName;
      selectElement2.multiple = props2.selectMultiple;
      inputEl.current.appendChild(selectElement2);
      setSelectElement(selectElement2);
      return () => setSelectElement(void 0);
    }
  }, [inputEl]);
  (0, import_react.useEffect)(() => {
    if (choicesObj) {
      choicesObj.containerInner.element.className = containerClassName;
    }
  }, [props2.className]);
  (0, import_react.useEffect)(() => {
    if (choicesObj && availableChoices) {
      choicesObj.setChoices(availableChoices, props2.idField, props2.labelField, true);
      choicesObj._q_items = new Map(availableChoices.map((item) => [item[props2.idField], item]));
      const choicesValues = choicesObj.getValue(true);
      const selectedValues = selected;
      if (!(0, import_dequal.dequal)(choicesValues, selectedValues)) {
        if (Array.isArray(selectedValues)) {
          selectedValues.forEach((value) => {
            if (void 0 === choicesObj._q_items.get(value)) {
              choicesObj.removeActiveItemsByValue(value);
            } else {
              choicesObj.setChoiceByValue(selectedValues);
            }
          });
        } else {
          if (void 0 === choicesObj._q_items.get(selectedValues)) {
            choicesObj.setChoiceByValue(null);
          } else {
            choicesObj.setChoiceByValue(selectedValues);
          }
        }
      }
    }
  }, [choicesObj, availableChoices]);
  (0, import_react.useEffect)(() => {
    if (choicesObj) {
      props2.readOnly ? choicesObj.disable() : choicesObj.enable();
    }
  }, [choicesObj, props2.readOnly]);
  (0, import_react.useEffect)(() => {
    setAvailableChoices(props2.choices.filter(Boolean));
  }, [props2.choices]);
  (0, import_react.useEffect)(() => {
    setSelected((cur) => {
      let proposed;
      if (Array.isArray(props2.selected)) {
        proposed = props2.selected.length > 0 ? props2.selected.map((item) => item[props2.idField]) : null;
      } else if (null == props2.selected || void 0 === props2.selected) {
        proposed = null;
      } else {
        proposed = props2.selected[props2.idField];
      }
      if ((0, import_dequal.dequal)(cur, proposed)) {
        return cur;
      }
      return proposed;
    });
  }, [props2.selected]);
  (0, import_react.useEffect)(() => {
    if (choicesObj) {
      const currentlySelectedInChoices = choicesObj.getValue(true);
      if (selected) {
        choicesObj.setChoiceByValue(selected);
      } else {
        choicesObj.clearStore();
        choicesObj.setChoices(availableChoices, props2.idField, props2.labelField, true);
      }
    }
  }, [choicesObj, selected]);
  return /* @__PURE__ */ import_react.default.createElement("div", {
    ref: inputEl
  });
}
Choices.propTypes = {
  className: import_prop_types.default.string,
  inputName: import_prop_types.default.string,
  choices: import_prop_types.default.array,
  idField: import_prop_types.default.string,
  labelField: import_prop_types.default.string,
  onChange: import_prop_types.default.func,
  selectMultiple: import_prop_types.default.bool,
  selected: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.arrayOf(import_prop_types.default.object)]),
  readOnly: import_prop_types.default.bool
};
Choices.defaultProps = {
  inputName: "choices",
  choices: [],
  idField: "id",
  labelField: "name",
  readOnly: false
};

// src/components/EmailAddress.jsx
var import_react2 = __toESM(require("react"));
var import_prop_types2 = __toESM(require("prop-types"));
function EmailAddress({ value, inputName, label, required, onValueValidated, onValueInvalidated, readOnly }) {
  const [inputValue, setInputValue] = (0, import_react2.useState)(value || "");
  const [prevInputValue, setPrevInputValue] = (0, import_react2.useState)();
  const [valid, setValid] = (0, import_react2.useState)();
  const [prevValid, setPrevValid] = (0, import_react2.useState)();
  (0, import_react2.useEffect)(() => setInputValue(value || ""), [value, setInputValue]);
  (0, import_react2.useEffect)(() => {
    const regex = /^\S+@\S+\.\S{2,}$/;
    const validity = inputValue.length == 0 || regex.test(inputValue);
    if (validity) {
      if (inputValue == "" && required) {
        setValid(false);
      } else {
        setValid(true);
      }
    } else {
      setValid(false);
    }
  }, [setValid, inputValue, required]);
  (0, import_react2.useEffect)(() => {
    if (void 0 === valid || void 0 === inputValue) {
    } else {
      if (!valid && onValueInvalidated && prevInputValue !== inputValue) {
        onValueInvalidated(inputValue);
      } else if (valid && onValueValidated && prevInputValue !== inputValue) {
        onValueValidated(inputValue);
      }
      if (prevValid !== valid) {
        setPrevValid(valid);
      }
      ;
      if (prevInputValue !== value) {
        setPrevInputValue(inputValue);
      }
    }
  }, [prevValid, setPrevValid, valid, onValueValidated, onValueInvalidated, inputValue, prevInputValue, setPrevInputValue]);
  const onChange = function(event) {
    setInputValue(event.target.value);
  };
  return /* @__PURE__ */ import_react2.default.createElement("div", {
    className: "input-group"
  }, /* @__PURE__ */ import_react2.default.createElement("input", {
    type: "email",
    name: inputName,
    value: inputValue,
    onChange,
    readOnly,
    className: `form form-control form-control-sm w-100 is-${valid ? "valid" : "invalid"}`,
    required
  }));
}
EmailAddress.propTypes = {
  inputName: import_prop_types2.default.string,
  value: import_prop_types2.default.string,
  label: import_prop_types2.default.string,
  required: import_prop_types2.default.bool,
  onValueValidated: import_prop_types2.default.func,
  onValueInvalidated: import_prop_types2.default.func,
  readOnly: import_prop_types2.default.bool
};

// src/components/EntityAndValueBadge.jsx
var import_react3 = __toESM(require("react"));
INCLUDE = "include";
EXCLUDE = "exclude";
OPERATOR_REGEX = /^[!~]/;
var stripOperator = (value) => {
  if (value?.hasOwnProperty("_filterOperator")) {
    delete value._filterOperator;
  } else if (typeof value == "string") {
    value = value.replace(OPERATOR_REGEX, "");
  }
  return value;
};
var getOperator = (value) => {
  const lookup = { "!": EXCLUDE };
  if (value?.hasOwnProperty("_filterOperator")) {
    return lookup[value._filterOperator] || INCLUDE;
  } else if (typeof value == "string") {
    return lookup[value.match(OPERATOR_REGEX)?.[0]] || INCLUDE;
  }
  return INCLUDE;
};
var selectableValue = function(entity, values) {
  return values?.map((item) => {
    if (!item) {
      return item;
    }
    if (item.value) {
      return item.value;
    }
    const id = stripOperator(typeof item === "string" ? item : item.id);
    return id ? entity.values.find((ev) => ev.id == id)?.value : item;
  }).sort().join(", ");
};
function EntityAndValueBadge({ entity, value, onRemove, className, operator }) {
  const entityName = entity.name;
  const values = Array.isArray(value) ? value : [value].flat();
  const displayValue = (0, import_react3.useMemo)(() => {
    switch (entity.type) {
      case "entity-toggle": {
        return typeof values[0] === "boolean" ? values[0]?.toString() : values[0]?.value.toString() || "";
      }
      case "entity-single-select":
      case "entity-multi-select": {
        return selectableValue(entity, values);
      }
      case "entity-date": {
        return value ? new Date(value).toLocaleDateString() : "";
      }
      case "entity-string": {
        return stripOperator(values[0]) || "";
      }
    }
  }, [values]);
  const displayJoin = (0, import_react3.useMemo)(() => {
    switch (entity.type) {
      case "entity-toggle": {
        return "=";
      }
      case "entity-single-select": {
        return getOperator(values[0]) == INCLUDE ? "=" : " is not ";
      }
      case "entity-date": {
        return "=";
      }
      case "entity-multi-select": {
        const op = getOperator(values[0]);
        return values.length > 1 ? ` ${op}s all of ` : ` ${op}s `;
      }
      case "entity-string": {
        return values[0]?.startsWith("~") ? " includes " : "=";
      }
    }
  }, [entity, values]);
  const badgeText = `${entityName}${displayJoin}${displayValue}`;
  const badgeClassName = `m-1 pt-0 pb-0 badge bg-secondary entity-and-value-badge ${className || ""}`;
  if (onRemove) {
    return /* @__PURE__ */ import_react3.default.createElement("span", {
      className: badgeClassName
    }, /* @__PURE__ */ import_react3.default.createElement("span", {
      className: "pb-2 pt-1"
    }, badgeText), /* @__PURE__ */ import_react3.default.createElement("span", {
      className: "btn btn-sm p-0 ps-1 border-0",
      onClick: onRemove
    }, /* @__PURE__ */ import_react3.default.createElement("span", {
      className: "fe fe-x text-white"
    })));
  }
  return /* @__PURE__ */ import_react3.default.createElement("span", {
    className: badgeClassName
  }, badgeText);
}

// src/components/EntityAndValuePicker.jsx
var import_react19 = __toESM(require("react"));
var import_prop_types18 = __toESM(require("prop-types"));
var import_quake_sdk16 = require("@quake-saas/quake-sdk");

// src/components/EntityPicker.jsx
var import_react4 = __toESM(require("react"));
var import_prop_types3 = __toESM(require("prop-types"));
var import_quake_sdk = require("@quake-saas/quake-sdk");
var EntityPicker = class extends import_react4.default.Component {
  constructor(props2) {
    super(props2);
    this.loadEntities = this.loadEntities.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = {};
    this.state.entities = this.props.entities || this.loadEntities() || [];
    this.state.value = this.props.value;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.entities != this.props.entities) {
      this.setState({ entities: this.props.entities });
    }
    if (!this.props.entities && prevProps.entityFilters != this.props.entityFilters && !this.props.readOnly) {
      this.loadEntities();
    }
    if (prevProps.value?.id != this.props.value?.id) {
      if (this.state.value?.id != this.props.value?.id) {
        this.setState({ value: this.props.value });
      }
    }
  }
  render() {
    if (this.props.readOnly) {
      return /* @__PURE__ */ import_react4.default.createElement("input", {
        className: "form-control form-control-sm",
        type: "text",
        disabled: true,
        name: this.props.inputName,
        value: this.props.value?.name || ""
      });
    } else {
      return /* @__PURE__ */ import_react4.default.createElement(Choices, {
        selectMultiple: false,
        onChange: this.onChange,
        allowRemove: this.props.allowNull,
        choices: this.state.entities,
        selected: this.state.value,
        inputName: this.props.inputName,
        labelField: "name"
      });
    }
  }
  loadEntities() {
    let callback = function(entities) {
      this.setState({ entities });
    };
    callback = callback.bind(this);
    import_quake_sdk.Entity.list({ pageSize: 50, filters: this.props.entityFilters }).then(callback);
  }
  onChange(selection) {
    this.setState({ value: selection });
    if (this.props.onChange) {
      this.props.onChange(selection);
    }
  }
};
__publicField(EntityPicker, "propTypes", {
  entities: import_prop_types3.default.arrayOf(import_prop_types3.default.shape({ id: import_prop_types3.default.string })),
  entityFilters: import_prop_types3.default.object,
  value: import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.instanceOf(import_quake_sdk.Entity), import_prop_types3.default.shape({ id: import_prop_types3.default.string, type: import_prop_types3.default.string, name: import_prop_types3.default.string })]),
  onChange: import_prop_types3.default.func,
  allowNull: import_prop_types3.default.bool,
  readOnly: import_prop_types3.default.bool,
  inputName: import_prop_types3.default.string
});
__publicField(EntityPicker, "defaultProps", {
  allowNull: false,
  readOnly: false,
  entityFilters: {},
  inputName: "entity-picker"
});

// src/components/EntityValue.jsx
var import_react18 = __toESM(require("react"));
var import_prop_types17 = __toESM(require("prop-types"));
var import_quake_sdk15 = require("@quake-saas/quake-sdk");

// src/components/EntityValue/String.jsx
var import_react5 = __toESM(require("react"));
var import_prop_types4 = __toESM(require("prop-types"));
var import_quake_sdk2 = require("@quake-saas/quake-sdk");
var EntityValueString = class extends import_react5.default.Component {
  constructor(props2) {
    super(props2);
    this.onChange = this.onChange.bind(this);
    this.isValid = this.isValid.bind(this);
  }
  render() {
    return this.props.readOnly ? this.renderReadOnly() : this.renderWritable();
  }
  renderReadOnly() {
    return /* @__PURE__ */ import_react5.default.createElement(import_react5.default.Fragment, null, this.props.value);
  }
  renderWritable() {
    const valid = this.isValid(this.props.value);
    const classes = "form-control form-control-sm string-entity " + (valid ? "is-valid" : "is-invalid");
    if (this.props.compact) {
      return /* @__PURE__ */ import_react5.default.createElement("input", {
        className: classes,
        name: this.props.inputName,
        value: this.props.value || "",
        onChange: this.onChange,
        required: !this.props.allowNull,
        type: "text"
      });
    } else {
      return /* @__PURE__ */ import_react5.default.createElement("textarea", {
        className: classes,
        name: this.props.inputName,
        onChange: this.onChange,
        required: !this.props.allowNull,
        value: this.props.value || ""
      });
    }
  }
  isValid(value) {
    return value && value.trim().length > 0 || this.props.allowNull;
  }
  onChange(event) {
    let val = event.target.value;
    if (val.trim().length == 0) {
      val = null;
    }
    if (this.isValid(val)) {
      this.props.onValid(val);
    } else {
      this.props.onInvalid(null);
    }
  }
};
__publicField(EntityValueString, "propTypes", {
  compact: import_prop_types4.default.bool,
  value: import_prop_types4.default.any,
  onValid: import_prop_types4.default.func,
  onInvalid: import_prop_types4.default.func,
  entity: import_prop_types4.default.oneOfType([
    import_prop_types4.default.shape({ id: import_prop_types4.default.string, type: import_prop_types4.default.oneOf(["entity-string"]) }),
    import_prop_types4.default.instanceOf(import_quake_sdk2.Entity.String)
  ]),
  allowNull: import_prop_types4.default.bool,
  inputName: import_prop_types4.default.string,
  allowedValues: import_prop_types4.default.array,
  readOnly: import_prop_types4.default.bool
});
__publicField(EntityValueString, "defaultProps", {
  allowNull: true,
  compact: true,
  inputName: "string-entity-choice",
  onValid: function(value) {
    console.log("entered " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("entered an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
});

// src/components/EntityValue/Toggle.jsx
var import_react6 = __toESM(require("react"));
var import_prop_types5 = __toESM(require("prop-types"));
var import_uuid = require("uuid");
var import_quake_sdk3 = require("@quake-saas/quake-sdk");
var Toggle = class extends import_react6.default.Component {
  constructor(props2) {
    super(props2);
    this.onChange = this.onChange.bind(this);
    this.uuid = (0, import_uuid.v4)();
  }
  render() {
    return this.props.readOnly ? this.renderReadOnly() : this.renderWritable();
  }
  renderReadOnly() {
    const entity = this.props.entity;
    let value = this.props.value;
    if (value === null || value === void 0) {
      value = "unset";
    }
    return /* @__PURE__ */ import_react6.default.createElement("span", {
      className: "badge bg-secondary-soft text-uppercase"
    }, value.toString());
  }
  renderWritable() {
    const trueLabel = "Yes";
    const falseLabel = "No";
    const classes = "form-check-input ";
    const value = this.props.value == "true" || this.props.value === true ? true : this.props.value == "false" || this.props.value === false ? false : void 0;
    if (this.props.allowNull || !this.props.compact) {
      return /* @__PURE__ */ import_react6.default.createElement("div", {
        className: `entity-toggle-selector form-check-inline tristate-boolean ${this.props.compact && "compact"}`
      }, /* @__PURE__ */ import_react6.default.createElement("label", {
        className: "selector-false"
      }, falseLabel), /* @__PURE__ */ import_react6.default.createElement("div", {
        className: "input-group"
      }, /* @__PURE__ */ import_react6.default.createElement("input", {
        type: "radio",
        id: `${this.uuid}-f`,
        className: `tristate tristate-false ${classes}`,
        name: this.props.name || this.uuid,
        checked: value === false,
        onChange: this.onChange,
        value: false,
        required: false
      }), /* @__PURE__ */ import_react6.default.createElement("input", {
        type: "radio",
        id: `${this.uuid}-u`,
        className: `tristate tristate-unset ${classes}`,
        name: this.props.name || this.uuid,
        checked: value === void 0,
        onChange: this.onChange,
        value: "undefined",
        required: false
      }), /* @__PURE__ */ import_react6.default.createElement("input", {
        type: "radio",
        id: `${this.uuid}-t`,
        className: `tristate tristate-true ${classes}`,
        name: this.props.name || this.uuid,
        checked: value === true,
        onChange: this.onChange,
        value: true,
        required: false
      })), /* @__PURE__ */ import_react6.default.createElement("label", {
        className: "selector-true"
      }, trueLabel));
    }
    return /* @__PURE__ */ import_react6.default.createElement("div", {
      className: `entity-toggle-selector form-check form-switch ${this.props.compact && "compact"}`
    }, /* @__PURE__ */ import_react6.default.createElement("label", {
      className: "selector-false"
    }, falseLabel), /* @__PURE__ */ import_react6.default.createElement("input", {
      type: "checkbox",
      className: classes,
      name: this.props.name,
      checked: value,
      value: true,
      onChange: this.onChange,
      required: !this.props.allowNull
    }), /* @__PURE__ */ import_react6.default.createElement("label", {
      className: "selector-true"
    }, trueLabel));
  }
  onChange(event) {
    let checked = event.target.checked;
    let value = checked && event.target.value;
    if (value === "undefined") {
      value = void 0;
    }
    if (value === "true") {
      value = true;
    }
    if (value === "false") {
      value = false;
    }
    this.props.onValid(value);
  }
};
__publicField(Toggle, "propTypes", {
  value: import_prop_types5.default.any,
  onValid: import_prop_types5.default.func,
  onInvalid: import_prop_types5.default.func,
  entity: import_prop_types5.default.oneOfType([
    import_prop_types5.default.shape({ id: import_prop_types5.default.string, type: import_prop_types5.default.oneOf(["entity-toggle"]) }),
    import_prop_types5.default.instanceOf(import_quake_sdk3.Entity.Toggle)
  ]),
  allowNull: import_prop_types5.default.bool,
  compact: import_prop_types5.default.bool,
  name: import_prop_types5.default.string,
  allowedValues: import_prop_types5.default.array,
  readOnly: import_prop_types5.default.bool
});
__publicField(Toggle, "defaultProps", {
  allowNull: true,
  compact: true,
  name: "toggle-entity-choice",
  onValid: function(value) {
    console.log("entered " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("entered an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
});

// src/components/EntityValue/MultiSelect.jsx
var import_react11 = __toESM(require("react"));
var import_prop_types10 = __toESM(require("prop-types"));
var import_quake_sdk8 = require("@quake-saas/quake-sdk");

// src/components/EntityValue/Select.jsx
var import_react10 = __toESM(require("react"));
var import_prop_types9 = __toESM(require("prop-types"));
var import_quake_sdk7 = require("@quake-saas/quake-sdk");

// src/components/EntityValue/ChoicesSelectable.jsx
var import_react8 = __toESM(require("react"));
var import_prop_types7 = __toESM(require("prop-types"));
var import_quake_sdk5 = require("@quake-saas/quake-sdk");

// src/components/EntityValue/ReadOnlySelectable.jsx
var import_prop_types6 = __toESM(require("prop-types"));
var import_react7 = __toESM(require("react"));
var import_quake_sdk4 = require("@quake-saas/quake-sdk");
var DisplayValue = ({ entity, value, badgeClass }) => {
  const idOrValue = value.hasOwnProperty("id") ? value.id : value;
  const [display, setDisplay] = import_react7.default.useState("");
  (0, import_react7.useEffect)(() => {
    if (entity && value) {
      const found = entity.findValue(idOrValue);
      if (found instanceof Promise) {
        found.then((result) => setDisplay(result));
      } else {
        setDisplay(found);
      }
    }
  }, [entity, value]);
  return /* @__PURE__ */ import_react7.default.createElement("span", {
    className: badgeClass
  }, display);
};
function ReadOnlySelectable({ entity, value, badgeClass = "badge bg-secondary-soft me-1" }) {
  if (entity) {
    let badges = [];
    if (value) {
      [value].flat().forEach((item, index) => {
        return badges.push(/* @__PURE__ */ import_react7.default.createElement(DisplayValue, {
          key: index,
          entity,
          value: item,
          badgeClass
        }));
      });
    }
    return /* @__PURE__ */ import_react7.default.createElement(import_react7.default.Fragment, null, badges);
  }
}
ReadOnlySelectable.propTypes = {
  entity: import_prop_types6.default.oneOfType(
    [
      import_prop_types6.default.instanceOf(import_quake_sdk4.Entity.SingleSelect),
      import_prop_types6.default.instanceOf(import_quake_sdk4.Entity.MultiSelect),
      import_prop_types6.default.shape({
        id: import_prop_types6.default.string,
        type: import_prop_types6.default.oneOf(["entity-single-select", "entity-multi-select"]),
        values: import_prop_types6.default.arrayOf(import_prop_types6.default.shape({ id: import_prop_types6.default.string, value: import_prop_types6.default.string }))
      }),
      import_prop_types6.default.shape({
        id: import_prop_types6.default.string,
        type: import_prop_types6.default.oneOf(["entity-contact", "entity-object"])
      })
    ]
  ),
  value: import_prop_types6.default.any,
  badgeClass: import_prop_types6.default.string
};

// src/components/EntityValue/ChoicesSelectable.jsx
var ChoicesSelectable = class extends import_react8.default.Component {
  constructor(props2) {
    super(props2);
    this.onChange = this.onChange.bind(this);
    this.isValid = this.isValid.bind(this);
    this.state = {};
    this.state.allowedValues = props2.allowedValues ? props2.allowedValues : props2.entity.values;
    this.findFromValueOrId = this.findFromValueOrId.bind(this);
    this.findAllFromValueOrId = this.findAllFromValueOrId.bind(this);
    this.allowRemove = this.allowRemove.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.allowedValues != this.props.allowedValues) {
      this.setState({ allowedValues: this.props.allowedValues || props.entity.values });
    }
  }
  render() {
    return this.props.readOnly ? this.renderReadOnly() : this.renderWritable();
  }
  renderReadOnly() {
    return /* @__PURE__ */ import_react8.default.createElement(ReadOnlySelectable, {
      entity: this.props.entity,
      value: this.props.value,
      badgeClass: this.props.readOnlyBadgeClass
    });
  }
  renderWritable() {
    const currentValues = this.findAllFromValueOrId(this.props.value) || [];
    const selected = this.props.multi ? currentValues : currentValues[0] || null;
    return /* @__PURE__ */ import_react8.default.createElement(Choices, {
      selectMultiple: this.props.multi,
      onChange: this.onChange,
      allowRemove: this.allowRemove(),
      choices: this.state.allowedValues,
      selected,
      inputName: this.props.inputName,
      labelField: "value"
    });
  }
  allowRemove() {
    if (this.props.multi) {
      return true;
    } else {
      return this.props.allowNull;
    }
  }
  findFromValueOrId(valueOrId) {
    if (valueOrId && valueOrId.id) {
      return valueOrId;
    } else if (!valueOrId) {
      return null;
    } else {
      return this.state.allowedValues.find((elem) => elem.id == (valueOrId?.id || valueOrId));
    }
  }
  findAllFromValueOrId(valuesOrIds) {
    if (!valuesOrIds) {
      return null;
    }
    if (!(valuesOrIds instanceof Array)) {
      valuesOrIds = [valuesOrIds];
    }
    return valuesOrIds.map(this.findFromValueOrId);
  }
  isValid(values) {
    if (this.props.multi) {
      if (!values || values == []) {
        return this.props.allowNull;
      } else {
        return true;
      }
    } else {
      return values || this.props.allowNull;
    }
  }
  onChange(values) {
    if (this.isValid(values)) {
      this.props.onValid(values);
    } else {
      this.props.onInvalid(values);
    }
  }
};
__publicField(ChoicesSelectable, "propTypes", {
  value: import_prop_types7.default.any,
  onValid: import_prop_types7.default.func,
  onInvalid: import_prop_types7.default.func,
  entity: import_prop_types7.default.oneOfType([
    import_prop_types7.default.instanceOf(import_quake_sdk5.Entity.SingleSelect),
    import_prop_types7.default.instanceOf(import_quake_sdk5.Entity.MultiSelect),
    import_prop_types7.default.shape({
      id: import_prop_types7.default.string,
      type: import_prop_types7.default.oneOf(["entity-single-select", "entity-multi-select"]),
      values: import_prop_types7.default.arrayOf(import_prop_types7.default.shape({ id: import_prop_types7.default.string, value: import_prop_types7.default.string }))
    }),
    import_prop_types7.default.shape({
      id: import_prop_types7.default.string,
      type: import_prop_types7.default.oneOf(["entity-contact", "entity-object"])
    })
  ]),
  allowNull: import_prop_types7.default.bool,
  inputName: import_prop_types7.default.string,
  allowedValues: import_prop_types7.default.array,
  multi: import_prop_types7.default.bool,
  readOnly: import_prop_types7.default.bool,
  readOnlyBadgeClass: import_prop_types7.default.string
});
__publicField(ChoicesSelectable, "defaultProps", {
  allowNull: true,
  inputName: "select-entity-choice",
  onValid: function(value) {
    console.log("chose " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("chose an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
});

// src/components/EntityValue/ButtonSelectable.jsx
var import_react9 = __toESM(require("react"));
var import_prop_types8 = __toESM(require("prop-types"));
var import_quake_sdk6 = require("@quake-saas/quake-sdk");
function ButtonSelectable({ entity, allowedValues, multi, inputName, value, onValid, onInvalid, allowNull, readOnly, ...props2 }) {
  const inputGroupRef = (0, import_react9.useRef)();
  const [isValid, setIsValid] = (0, import_react9.useState)();
  allowedValues ||= entity.values;
  value = [value].flat().filter(Boolean);
  const valueIds = value.map((val) => val.id);
  const inputType = multi ? "checkbox" : "radio";
  const handleChange = (evt) => {
    let selectedIds = [];
    inputGroupRef.current.querySelectorAll("input").forEach((elem) => elem.checked && selectedIds.push(elem.value));
    let selected = allowedValues.filter((elem) => selectedIds.includes(elem.id));
    if (selected.length == 0) {
      if (allowNull) {
        setIsValid(true);
        onValid(selected);
      } else {
        setIsValid(false);
        onInvalid(selected);
      }
    } else {
      setIsValid(true);
      onValid(selected);
    }
  };
  const options = allowedValues.map((elem) => {
    const isChecked = valueIds.includes(elem.id);
    const labelClasses = `item ${allowNull ? "" : "required"} ${isChecked ? "selected" : ""} ${isValid ? "valid" : "invalid"} ${readOnly ? "readonly" : ""}`;
    return /* @__PURE__ */ import_react9.default.createElement("label", {
      className: labelClasses,
      key: elem.id
    }, /* @__PURE__ */ import_react9.default.createElement("input", {
      type: inputType,
      value: elem.id,
      name: inputName,
      readOnly,
      onChange: handleChange,
      checked: isChecked
    }), /* @__PURE__ */ import_react9.default.createElement("span", null, elem.value));
  });
  return /* @__PURE__ */ import_react9.default.createElement("div", {
    className: `entity-select entity-select-${multi ? "multiple" : "single"}`,
    ref: inputGroupRef
  }, options);
}
ButtonSelectable.propTypes = {
  value: import_prop_types8.default.any,
  onValid: import_prop_types8.default.func,
  onInvalid: import_prop_types8.default.func,
  entity: import_prop_types8.default.oneOfType([
    import_prop_types8.default.instanceOf(import_quake_sdk6.Entity.SingleSelect),
    import_prop_types8.default.instanceOf(import_quake_sdk6.Entity.MultiSelect),
    import_prop_types8.default.shape({
      id: import_prop_types8.default.string,
      type: import_prop_types8.default.oneOf(["entity-single-select", "entity-multi-select"]),
      values: import_prop_types8.default.arrayOf(import_prop_types8.default.shape({ id: import_prop_types8.default.string, value: import_prop_types8.default.string }))
    })
  ]),
  allowNull: import_prop_types8.default.bool,
  inputName: import_prop_types8.default.string,
  allowedValues: import_prop_types8.default.array,
  multi: import_prop_types8.default.bool,
  readOnly: import_prop_types8.default.bool
};
ButtonSelectable.defaultProps = {
  allowNull: true,
  inputName: "select-entity-choice",
  onValid: function(value) {
    console.log("chose " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("chose an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
};

// src/components/EntityValue/Select.jsx
function Select({ compact, ...props2 }) {
  return compact ? /* @__PURE__ */ import_react10.default.createElement(ChoicesSelectable, {
    ...props2
  }) : /* @__PURE__ */ import_react10.default.createElement(ButtonSelectable, {
    ...props2
  });
}
Select.propTypes = {
  value: import_prop_types9.default.any,
  onValid: import_prop_types9.default.func,
  onInvalid: import_prop_types9.default.func,
  entity: import_prop_types9.default.oneOfType([
    import_prop_types9.default.shape({
      id: import_prop_types9.default.string,
      type: import_prop_types9.default.oneOf(["entity-multi-select", "entity-single-select"]),
      values: import_prop_types9.default.arrayOf(import_prop_types9.default.shape({ id: import_prop_types9.default.string, value: import_prop_types9.default.string }))
    }),
    import_prop_types9.default.shape({
      id: import_prop_types9.default.string,
      type: import_prop_types9.default.oneOf(["entity-contact", "entity-object"])
    }),
    import_prop_types9.default.instanceOf(import_quake_sdk7.Entity.MultiSelect),
    import_prop_types9.default.instanceOf(import_quake_sdk7.Entity.SingleSelect),
    import_prop_types9.default.instanceOf(import_quake_sdk7.Entity.Object)
  ]),
  allowNull: import_prop_types9.default.bool,
  inputName: import_prop_types9.default.string,
  allowedValues: import_prop_types9.default.array,
  multi: import_prop_types9.default.bool,
  compact: import_prop_types9.default.bool,
  readOnly: import_prop_types9.default.bool,
  readOnlyBadgeClass: import_prop_types9.default.string
};
Select.defaultProps = {
  allowNull: true,
  compact: true,
  inputName: "select-entity-choice",
  onValid: function(value) {
    console.log("chose " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("chose an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
};

// src/components/EntityValue/MultiSelect.jsx
var MultiSelect = class extends import_react11.default.Component {
  render() {
    return /* @__PURE__ */ import_react11.default.createElement(Select, {
      multi: true,
      ...this.props
    });
  }
};
__publicField(MultiSelect, "propTypes", {
  value: import_prop_types10.default.any,
  onValid: import_prop_types10.default.func,
  onInvalid: import_prop_types10.default.func,
  entity: import_prop_types10.default.oneOfType([
    import_prop_types10.default.shape({
      id: import_prop_types10.default.string,
      type: import_prop_types10.default.oneOf(["entity-multi-select"]),
      values: import_prop_types10.default.arrayOf(import_prop_types10.default.shape({ id: import_prop_types10.default.string, value: import_prop_types10.default.string }))
    }),
    import_prop_types10.default.instanceOf(import_quake_sdk8.Entity.MultiSelect)
  ]),
  allowNull: import_prop_types10.default.bool,
  inputName: import_prop_types10.default.string,
  allowedValues: import_prop_types10.default.array,
  readOnly: import_prop_types10.default.bool,
  readOnlyBadgeClass: import_prop_types10.default.string
});
__publicField(MultiSelect, "defaultProps", {
  allowNull: true,
  inputName: "multiselect-entity-choice",
  onValid: function(value) {
    console.log("chose " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("chose an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
});

// src/components/EntityValue/SingleSelect.jsx
var import_react12 = __toESM(require("react"));
var import_prop_types11 = __toESM(require("prop-types"));
var import_quake_sdk9 = require("@quake-saas/quake-sdk");
var SingleSelect = class extends import_react12.default.Component {
  render() {
    return /* @__PURE__ */ import_react12.default.createElement(Select, {
      multi: false,
      ...this.props
    });
  }
};
__publicField(SingleSelect, "propTypes", {
  value: import_prop_types11.default.any,
  onValid: import_prop_types11.default.func,
  onInvalid: import_prop_types11.default.func,
  entity: import_prop_types11.default.oneOfType([
    import_prop_types11.default.shape({
      id: import_prop_types11.default.string,
      type: import_prop_types11.default.oneOf(["entity-single-select"]),
      values: import_prop_types11.default.arrayOf(import_prop_types11.default.shape({ id: import_prop_types11.default.string, value: import_prop_types11.default.string }))
    }),
    import_prop_types11.default.instanceOf(import_quake_sdk9.Entity.SingleSelect)
  ]),
  allowNull: import_prop_types11.default.bool,
  inputName: import_prop_types11.default.string,
  allowedValues: import_prop_types11.default.array,
  readOnly: import_prop_types11.default.bool,
  readOnlyBadgeClass: import_prop_types11.default.string
});
__publicField(SingleSelect, "defaultProps", {
  allowNull: true,
  inputName: "singleselect-entity-choice",
  onValid: function(value) {
    console.log("chose " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("chose an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
});

// src/components/EntityValue/Attachment.jsx
var import_react13 = __toESM(require("react"));
var import_prop_types12 = __toESM(require("prop-types"));
var import_quake_sdk10 = require("@quake-saas/quake-sdk");
var buildReadOnly = function(value) {
  if (value) {
    let innerTag;
    if (value.contentType?.startsWith("image")) {
      innerTag = /* @__PURE__ */ import_react13.default.createElement("img", {
        src: value.url,
        style: { maxWidth: "100px", maxHeight: "100px" }
      });
    } else if (value.contentType?.startsWith("text/csv")) {
      innerTag = /* @__PURE__ */ import_react13.default.createElement("button", {
        className: "btn btn-outline-secondary btn-lg fe fe-file-text"
      });
    } else if (value.contentType == "application/pdf") {
      innerTag = /* @__PURE__ */ import_react13.default.createElement("button", {
        className: "btn btn-outline-secondary btn-lg fe fe-file-text"
      });
    } else if (value.contentType?.startsWith("video")) {
      innerTag = /* @__PURE__ */ import_react13.default.createElement("button", {
        className: "btn btn-outline-secondary btn-lg fe fe-film"
      });
    } else if (value.contentType?.startsWith("audio")) {
      innerTag = /* @__PURE__ */ import_react13.default.createElement("button", {
        className: "btn btn-outline-secondary btn-lg fe fe-headphones"
      });
    } else {
      innerTag = /* @__PURE__ */ import_react13.default.createElement("button", {
        className: "btn btn-outline-secondary btn-lg fe fe-file"
      });
    }
    return /* @__PURE__ */ import_react13.default.createElement("a", {
      href: value.url,
      target: "_blank"
    }, innerTag);
  } else {
    return /* @__PURE__ */ import_react13.default.createElement("span", null, "-");
  }
};
function Attachment({ value, entity, readOnly, inputName, onValid, onInvalid, onChange, allowNull }) {
  if (readOnly) {
    return buildReadOnly(value);
  }
  onValid ||= () => {
  };
  onInvalid ||= () => {
  };
  onChange ||= () => {
  };
  const handleChange = function(event) {
    const file = event.target.files[0];
    if (!file) {
      if (allowNull) {
        return onValid(null);
      }
      return onInvalid(null);
    }
    if (file.size > 20971520) {
      console.warn("File is too large");
      return onInvalid(file);
    }
    if (file.size == 0) {
      console.warn("File is too small");
      return onInvalid(file);
    }
    onValid(file);
  };
  const accept = "image/*,audio/*,video/*,.csv,.pdf,.doc,.docx";
  const capture = "user";
  return /* @__PURE__ */ import_react13.default.createElement("input", {
    type: "file",
    name: inputName,
    accept,
    onChange: handleChange,
    required: !allowNull
  });
}
Attachment.propTypes = {
  inputName: import_prop_types12.default.string,
  onValid: import_prop_types12.default.func,
  onInvalid: import_prop_types12.default.func,
  onChange: import_prop_types12.default.func,
  value: import_prop_types12.default.any,
  entity: import_prop_types12.default.oneOfType([
    import_prop_types12.default.shape({
      id: import_prop_types12.default.string,
      type: import_prop_types12.default.oneOf(["entity-attachment"])
    }),
    import_prop_types12.default.instanceOf(import_quake_sdk10.Entity.Attachment)
  ]),
  allowNull: import_prop_types12.default.bool,
  readOnly: import_prop_types12.default.bool
};
Attachment.defaultProps = {
  allowNull: true,
  readOnly: false
};

// src/components/EntityValue/Date.jsx
var import_react14 = __toESM(require("react"));
var import_prop_types13 = __toESM(require("prop-types"));
var import_react_flatpickr = __toESM(require("react-flatpickr"));
var import_quake_sdk11 = require("@quake-saas/quake-sdk");
var dateFormat = Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale, { dateStyle: "full", timeStyle: void 0 });
var parseDate = (t) => {
  const parsed = new Date(t);
  return isNaN(parsed) ? void 0 : parsed;
};
var formatDate = (value) => {
  const parsed = parseDate(value);
  return parsed ? dateFormat.format(parsed) : null;
};
var renderReadOnly = function(value) {
  return value ? /* @__PURE__ */ import_react14.default.createElement("span", null, formatDate(value)) : /* @__PURE__ */ import_react14.default.createElement(import_react14.default.Fragment, null);
};
var validate = function(value, entity, allowNull) {
  return allowNull ? true : !!value;
};
function EntityValueDate({ value, onChange, onValid, onInvalid, entity, allowNull, inputName, readOnly }) {
  if (readOnly) {
    return renderReadOnly(value);
  }
  const handleChange = ([newValue, _endValue]) => {
    newValue = newValue.toISOString().slice(0, 10);
    onChange && onChange(newValue);
    if (onValid || onInvalid) {
      if (validate(newValue, entity, allowNull)) {
        onValid && onValid(newValue);
      } else {
        onInvalid && onInvalid(newValue);
      }
    }
  };
  const valid = validate(value, entity, allowNull);
  const inputRenderer = inputName ? ({ defaultValue, value: value2, ...props2 }, ref) => /* @__PURE__ */ import_react14.default.createElement("input", {
    ...props2,
    defaultValue,
    ref,
    name: inputName
  }) : void 0;
  const opts = {
    altInput: true,
    altFormat: "j F, Y",
    altInputClass: `form form-control form-control-sm ${valid ? "is-valid" : "is-invalid"}`,
    defaultDate: new Date(),
    dateFormat: "Y-m-d",
    parseDate
  };
  return /* @__PURE__ */ import_react14.default.createElement("div", {
    className: "entity-date-selector",
    "data-entity-id": entity.id
  }, /* @__PURE__ */ import_react14.default.createElement(import_react_flatpickr.default, {
    key: `${entity.id} ${valid.toString()}`,
    value,
    onChange: handleChange,
    render: inputRenderer,
    options: opts
  }));
}
Date.propTypes = {
  value: import_prop_types13.default.any,
  inputName: import_prop_types13.default.string,
  onValid: import_prop_types13.default.func,
  onInvalid: import_prop_types13.default.func,
  onChange: import_prop_types13.default.func,
  entity: import_prop_types13.default.oneOfType([
    import_prop_types13.default.shape({ id: import_prop_types13.default.string, type: import_prop_types13.default.oneOf(["entity-date"]) }),
    import_prop_types13.default.instanceOf(import_quake_sdk11.Entity.Date)
  ]),
  allowNull: import_prop_types13.default.bool,
  readOnly: import_prop_types13.default.bool
};
Date.defaultProps = {
  allowNull: true,
  readOnly: false
};

// src/components/EntityValue/NPS.jsx
var import_react15 = __toESM(require("react"));
var import_prop_types14 = __toESM(require("prop-types"));
var import_quake_sdk12 = require("@quake-saas/quake-sdk");
var RANGE = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var npsClass = (value) => {
  if (value < 7)
    return "detractor";
  if (value < 9)
    return "neutral";
  return "promoter";
};
var renderReadOnly2 = function(value, entity) {
  return /* @__PURE__ */ import_react15.default.createElement("div", {
    className: `entity-nps-selector nps-option ${npsClass(value)} nps-${value}`,
    "data-entity-id": entity.id
  }, value);
};
var renderFull = function(onValid, value, entity, inputName) {
  const selected = (event) => {
    onValid(event.currentTarget.value);
  };
  const radios = RANGE.map((val) => {
    let classes = npsClass(val);
    const id = `${entity.id}-value-${val}`;
    return /* @__PURE__ */ import_react15.default.createElement("div", {
      key: val,
      className: `nps-option ${classes} nps-${val}`
    }, /* @__PURE__ */ import_react15.default.createElement("input", {
      type: "radio",
      id,
      name: inputName,
      value: val,
      checked: val == value,
      onChange: selected
    }), /* @__PURE__ */ import_react15.default.createElement("label", {
      htmlFor: id
    }, val));
  });
  return /* @__PURE__ */ import_react15.default.createElement("fieldset", {
    className: "entity-nps-selector",
    "data-entity-id": entity.id
  }, radios);
};
var renderCompact = function(onValid, value, entity, inputName) {
  const onChange = (val) => onValid(val.value);
  const values = RANGE.map((val) => ({ id: val, value: val }));
  const selected = value ? { id: value, value } : null;
  return /* @__PURE__ */ import_react15.default.createElement("div", {
    className: "entity-nps-selector",
    "data-entity-id": entity.id
  }, /* @__PURE__ */ import_react15.default.createElement(Choices, {
    selectMultiple: false,
    onChange,
    allowRemove: false,
    choices: values,
    selected,
    inputName,
    labelField: "value"
  }));
};
function NPS({ value, onValid, onInvalid, entity, allowNull, inputName, readOnly, compact }) {
  inputName ||= entity.id;
  if (readOnly) {
    return renderReadOnly2(value, entity);
  }
  if (compact) {
    return renderCompact(onValid, value, entity, inputName);
  }
  return renderFull(onValid, value, entity, inputName);
}
NPS.propTypes = {
  value: import_prop_types14.default.any,
  compact: import_prop_types14.default.bool,
  onValid: import_prop_types14.default.func,
  onInvalid: import_prop_types14.default.func,
  entity: import_prop_types14.default.oneOfType([
    import_prop_types14.default.shape({ id: import_prop_types14.default.string, type: import_prop_types14.default.oneOf(["entity-nps"]) }),
    import_prop_types14.default.instanceOf(import_quake_sdk12.Entity.NPS)
  ]),
  allowNull: import_prop_types14.default.bool,
  inputName: import_prop_types14.default.string,
  readOnly: import_prop_types14.default.bool
};
NPS.defaultProps = {
  allowNull: false,
  compact: true,
  inputName: "nps-entity",
  onValid: function(value) {
    console.log("entered " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("entered an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
};

// src/components/EntityValue/Numeric.jsx
var import_react16 = __toESM(require("react"));
var import_prop_types15 = __toESM(require("prop-types"));
var import_quake_sdk13 = require("@quake-saas/quake-sdk");
var EntityValueNumeric = class extends import_react16.default.Component {
  constructor(props2) {
    super(props2);
    this.onChange = this.onChange.bind(this);
    this.isValid = this.isValid.bind(this);
  }
  render() {
    return this.props.readOnly ? this.renderReadOnly() : this.renderWritable();
  }
  renderReadOnly() {
    return /* @__PURE__ */ import_react16.default.createElement(import_react16.default.Fragment, null, this.props.value);
  }
  renderWritable() {
    const valid = this.isValid(this.props.value);
    const classes = "form-control form-control-sm numeric-entity " + (valid ? "is-valid" : "is-invalid");
    return /* @__PURE__ */ import_react16.default.createElement("input", {
      className: classes,
      name: this.props.inputName,
      value: this.props.value || "",
      onChange: this.onChange,
      required: !this.props.allowNull,
      type: "number"
    });
  }
  isValid(value) {
    return value && value.toString().match(/^[\d\.-]+$/) || value === 0 || this.props.allowNull;
  }
  onChange(event) {
    let val = event.target.value;
    if (val.trim().length == 0) {
      val = null;
    }
    if (this.isValid(val)) {
      this.props.onValid(val);
    } else {
      this.props.onInvalid(null);
    }
  }
};
__publicField(EntityValueNumeric, "propTypes", {
  compact: import_prop_types15.default.bool,
  value: import_prop_types15.default.any,
  onValid: import_prop_types15.default.func,
  onInvalid: import_prop_types15.default.func,
  entity: import_prop_types15.default.oneOfType([
    import_prop_types15.default.shape({ id: import_prop_types15.default.string, type: import_prop_types15.default.oneOf(["entity-string"]) }),
    import_prop_types15.default.instanceOf(import_quake_sdk13.Entity.String)
  ]),
  allowNull: import_prop_types15.default.bool,
  inputName: import_prop_types15.default.string,
  allowedValues: import_prop_types15.default.array,
  readOnly: import_prop_types15.default.bool
});
__publicField(EntityValueNumeric, "defaultProps", {
  allowNull: true,
  compact: true,
  inputName: "string-entity-choice",
  onValid: function(value) {
    console.log("entered " + value + " for entity " + this.props.entity.id);
  },
  onInvalid: function(value) {
    console.log("entered an invalid value for entity " + this.props.entity.id);
  },
  readOnly: false
});

// src/components/EntityValue/Contact.jsx
var import_react17 = __toESM(require("react"));
var import_prop_types16 = __toESM(require("prop-types"));
var import_quake_sdk14 = require("@quake-saas/quake-sdk");
function Contact({ value, entity, onValid, onInvalid, allowNull, inputName, allowedValues, readOnly }) {
  readOnly = true;
  const [contacts, setContacts] = (0, import_react17.useState)({});
  const findValue = (id) => {
    if (contacts[id])
      return contacts[id];
    const promise = import_quake_sdk14.Contact.getById(id).then((contact) => [contact.firstName, contact.lastName].filter(Boolean).join(" ") || "unknown").catch(() => "unknown").then((name) => setContacts((inner) => ({ ...inner, [id]: name })));
    setContacts((cur) => {
      if (cur[id])
        return cur;
      return { ...cur, [id]: promise };
    });
    return promise;
  };
  return /* @__PURE__ */ import_react17.default.createElement(Select, {
    multi: true,
    value,
    onValid,
    onInvalid,
    allowNull,
    inputName,
    allowedValues,
    readOnly,
    entity: { ...entity, findValue }
  });
}
Contact.propTypes = {
  value: import_prop_types16.default.any,
  onValid: import_prop_types16.default.func,
  onInvalid: import_prop_types16.default.func,
  entity: import_prop_types16.default.oneOfType([
    import_prop_types16.default.shape({
      id: import_prop_types16.default.string,
      type: import_prop_types16.default.oneOf(["entity-contact"])
    }),
    import_prop_types16.default.instanceOf(import_quake_sdk14.Entity.MultiSelect)
  ]),
  allowNull: import_prop_types16.default.bool,
  inputName: import_prop_types16.default.string,
  allowedValues: import_prop_types16.default.array,
  readOnly: import_prop_types16.default.bool
};
Contact.defaultProps = {
  allowNull: true,
  inputName: "contact-entity-choice",
  onValid: function(value) {
    console.log("chose " + value + " for entity " + this.entity.id);
  },
  onInvalid: function(value) {
    console.log("chose an invalid value for entity " + this.entity.id);
  },
  readOnly: false
};

// src/components/EntityValue.jsx
var _EntityValue = class extends import_react18.default.Component {
  constructor(props2) {
    super(props2);
    this.loadEntity = this.loadEntity.bind(this);
    this.state = {};
    this.state.entity = this.props.entity || this.loadEntity(this.props.entityId) || {};
  }
  componentDidUpdate(prevProps) {
    if (prevProps.entity != this.props.entity) {
      this.setState({ entity: this.props.entity });
    } else if (!this.props.entity && prevProps.entityId != this.props.entityId) {
      this.loadEntity(this.props.entityId);
    }
  }
  render() {
    let inputType = _EntityValue.typeMapping[this.state.entity.type];
    if (!inputType && this.state.entity.isNumeric)
      inputType = EntityValueNumeric;
    const inputProps = {
      compact: this.props.compact,
      entity: this.state.entity,
      value: this.props.value,
      onValid: this.props.onValid,
      onInvalid: this.props.onInvalid,
      allowNull: this.props.allowNull,
      allowedValues: this.props.allowedValues,
      inputName: this.props.inputName,
      readOnly: this.props.readOnly,
      readOnlyBadgeClass: this.props.readOnlyBadgeClass
    };
    if (inputType) {
      return /* @__PURE__ */ import_react18.default.createElement("div", {
        className: this.props.className,
        key: this.state.entity.id
      }, import_react18.default.createElement(inputType, inputProps));
    } else if (!this.state.entity.type) {
      return /* @__PURE__ */ import_react18.default.createElement(import_react18.default.Fragment, null);
    } else {
      console.debug("Unknown type for entity", this.props.entity);
      return /* @__PURE__ */ import_react18.default.createElement(import_react18.default.Fragment, null);
    }
  }
  loadEntity(entityId) {
    if (entityId) {
      let callback = function(entity) {
        this.setState({ entity });
      };
      callback = callback.bind(this);
      import_quake_sdk15.Entity.getById(entityId).then(callback);
    }
  }
};
var EntityValue = _EntityValue;
__publicField(EntityValue, "propTypes", {
  value: import_prop_types17.default.any,
  onValid: import_prop_types17.default.func,
  onInvalid: import_prop_types17.default.func,
  entity: import_prop_types17.default.oneOfType([import_prop_types17.default.instanceOf(import_quake_sdk15.Entity), import_prop_types17.default.shape({ id: import_prop_types17.default.string, type: import_prop_types17.default.string })]),
  entityId: import_prop_types17.default.string,
  allowNull: import_prop_types17.default.bool,
  inputName: import_prop_types17.default.string,
  allowedValues: import_prop_types17.default.array,
  readOnly: import_prop_types17.default.bool,
  readOnlyBadgeClass: import_prop_types17.default.string,
  className: import_prop_types17.default.string,
  compact: import_prop_types17.default.bool
});
__publicField(EntityValue, "defaultProps", {
  allowNull: true,
  allowedValues: null,
  onValid: () => {
  },
  onInvalid: () => {
  }
});
__publicField(EntityValue, "typeMapping", {
  [import_quake_sdk15.Entity.Attachment.dataType]: Attachment,
  [import_quake_sdk15.Entity.Contact.dataType]: Contact,
  [import_quake_sdk15.Entity.Date.dataType]: EntityValueDate,
  [import_quake_sdk15.Entity.Toggle.dataType]: Toggle,
  [import_quake_sdk15.Entity.String.dataType]: EntityValueString,
  [import_quake_sdk15.Entity.MultiSelect.dataType]: MultiSelect,
  [import_quake_sdk15.Entity.SingleSelect.dataType]: SingleSelect,
  [import_quake_sdk15.Entity.NPS.dataType]: NPS,
  [import_quake_sdk15.Entity.Numeric.dataType]: EntityValueNumeric
});

// src/components/EntityAndValuePicker.jsx
var EntityAndValuePicker = class extends import_react19.default.Component {
  constructor(props2) {
    super(props2);
    this.loadEntities = this.loadEntities.bind(this);
    this.onEntityChange = this.onEntityChange.bind(this);
    this.onValidValueChange = this.onValidValueChange.bind(this);
    this.onInvalidValueChange = this.onInvalidValueChange.bind(this);
    this.entityPicker = this.entityPicker.bind(this);
    this.joinLabel = this.joinLabel.bind(this);
    this.state = { selectedEntity: props2.selectedEntity, value: props2.value, loading: !props2.entities };
    this.state.entities = props2.entities || this.loadEntities(props2.entityFilters) || [];
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.entities != this.props.entities) {
      this.setState({ entities: this.props.entities });
    } else if (!this.props.entities && prevProps.entityFilters != this.props.entityFilters) {
      this.setState({ loading: true });
      this.loadEntities(this.props.entityFilters);
    }
    if (prevProps.selectedEntity != this.props.selectedEntity) {
      this.setState({ selectedEntity: this.props.selectedEntity });
    }
    ;
    if (prevProps.value != this.props.value) {
      this.setState({ value: this.props.value });
    }
    ;
  }
  render() {
    return /* @__PURE__ */ import_react19.default.createElement("div", {
      className: "p-1 w-100 entity-value-picker"
    }, /* @__PURE__ */ import_react19.default.createElement("div", {
      className: "d-flex flex-row"
    }, /* @__PURE__ */ import_react19.default.createElement("div", {
      className: "col p-0 entity",
      "data-selected-entity-id": this.state.selectedEntity?.id || null
    }, this.entityPicker()), /* @__PURE__ */ import_react19.default.createElement("div", {
      className: "col-1 text-center align-self-center justify-content-center ps-1 pe-1 join"
    }, this.joinLabel()), /* @__PURE__ */ import_react19.default.createElement("div", {
      className: "col p-0 entity-value"
    }, /* @__PURE__ */ import_react19.default.createElement(EntityValue, {
      entity: this.state.selectedEntity,
      value: this.state.value,
      onValid: this.onValidValueChange,
      onInvalidValueChange: this.onInvalidValueChange,
      allowNull: false
    }))));
  }
  entityPicker() {
    if (this.state.loading) {
      return /* @__PURE__ */ import_react19.default.createElement("span", null, /* @__PURE__ */ import_react19.default.createElement("span", {
        className: "spinner-border spinner-border-sm text-primary"
      }), " loading...");
    } else {
      return /* @__PURE__ */ import_react19.default.createElement(EntityPicker, {
        entities: this.state.entities,
        value: this.state.selectedEntity,
        onChange: this.onEntityChange
      });
    }
  }
  joinLabel() {
    if (this.state.loading || !this.state.selectedEntity) {
      return /* @__PURE__ */ import_react19.default.createElement(import_react19.default.Fragment, null);
    } else {
      return this.props.joinLabel;
    }
  }
  loadEntities(entityFilters) {
    let callback = function(entities) {
      this.setState({ entities, loading: false });
    };
    callback = callback.bind(this);
    import_quake_sdk16.Entity.list({ pageSize: 50, filters: entityFilters }).then(callback);
  }
  onEntityChange(selection) {
    this.setState({ selectedEntity: selection, value: null });
    this.props.onEntityChange(selection);
  }
  onValidValueChange(value) {
    this.setState({ value });
    this.props.onValidValueChange(value);
  }
  onInvalidValueChange(value) {
    this.setState({ value });
    this.props.onInvalidValueChange(value);
  }
};
__publicField(EntityAndValuePicker, "propTypes", {
  entities: import_prop_types18.default.arrayOf(import_prop_types18.default.oneOfType([import_prop_types18.default.instanceOf(import_quake_sdk16.Entity), import_prop_types18.default.shape({ id: import_prop_types18.default.string })])),
  entityFilters: import_prop_types18.default.object,
  selectedEntity: import_prop_types18.default.oneOfType([import_prop_types18.default.string, import_prop_types18.default.instanceOf(import_quake_sdk16.Entity), import_prop_types18.default.shape({ id: import_prop_types18.default.string })]),
  value: import_prop_types18.default.any,
  onEntityChange: import_prop_types18.default.func,
  onValidValueChange: import_prop_types18.default.func,
  onInvalidValueChange: import_prop_types18.default.func,
  allowNull: import_prop_types18.default.bool,
  inputName: import_prop_types18.default.string,
  joinLabel: import_prop_types18.default.oneOfType([import_prop_types18.default.string, import_prop_types18.default.element])
});
__publicField(EntityAndValuePicker, "defaultProps", {
  allowNull: false,
  entityFilters: {},
  joinLabel: /* @__PURE__ */ import_react19.default.createElement(import_react19.default.Fragment, null, "=")
});

// src/components/EntityAndValueTag.jsx
var import_react20 = __toESM(require("react"));
function EntityAndValueTag({ entities, selectedEntity, value, readOnly, onClear, onApply }) {
  const [entity, setEntity] = (0, import_react20.useState)();
  const [newValue, setNewValue] = (0, import_react20.useState)();
  const apply = () => onApply(entity, newValue);
  if (selectedEntity) {
    const entity2 = selectedEntity?.type ? selectedEntity : entities.find((item) => item.id == selectedEntity.id);
    if (!entity2) {
      return /* @__PURE__ */ import_react20.default.createElement(import_react20.default.Fragment, null);
    }
    return /* @__PURE__ */ import_react20.default.createElement(EntityAndValueBadge, {
      entity: entity2,
      value,
      onRemove: readOnly ? void 0 : onClear
    });
  }
  return /* @__PURE__ */ import_react20.default.createElement("div", {
    className: "d-inline flex-grow-1 align-self-center"
  }, /* @__PURE__ */ import_react20.default.createElement("div", {
    className: "d-inline-block",
    style: { minWidth: "20em" }
  }, /* @__PURE__ */ import_react20.default.createElement(EntityAndValuePicker, {
    entities,
    selectedEntity: entity,
    value: newValue,
    onEntityChange: setEntity,
    onValidValueChange: setNewValue,
    onInvalidValueChange: () => setNewValue(void 0),
    allowNull: true
  })), /* @__PURE__ */ import_react20.default.createElement("div", {
    className: "d-inline align-self-center"
  }, /* @__PURE__ */ import_react20.default.createElement("button", {
    className: `btn btn-sm d-inline p-0`,
    onClick: apply,
    disabled: !newValue
  }, /* @__PURE__ */ import_react20.default.createElement("span", {
    className: "fe fe-check"
  })), /* @__PURE__ */ import_react20.default.createElement("button", {
    className: "btn btn-sm p-0",
    onClick: onClear
  }, /* @__PURE__ */ import_react20.default.createElement("span", {
    className: "x"
  }))));
}

// src/components/FlowPicker.jsx
var import_react21 = __toESM(require("react"));
var import_prop_types19 = __toESM(require("prop-types"));
var import_quake_sdk17 = require("@quake-saas/quake-sdk");
function FlowPicker({ flows, value, onChange, allowNull, inputName, readOnly, className }) {
  if (readOnly) {
    return /* @__PURE__ */ import_react21.default.createElement("div", {
      className: "choices"
    }, /* @__PURE__ */ import_react21.default.createElement("div", {
      className: `select custom-select form-control form-control-sm ${className || ""}`
    }, /* @__PURE__ */ import_react21.default.createElement("div", {
      className: "choices__list choices__list--single"
    }, /* @__PURE__ */ import_react21.default.createElement("select", {
      hidden: true
    }), /* @__PURE__ */ import_react21.default.createElement("div", {
      className: "choices__item choices__item--selectable"
    }, flows.filter((item) => item.id == value.id)[0]?.name))));
  }
  return /* @__PURE__ */ import_react21.default.createElement(Choices, {
    selectMultiple: false,
    onChange,
    allowRemove: allowNull,
    choices: flows,
    selected: value,
    inputName,
    className,
    labelField: "name"
  });
}
FlowPicker.propTypes = {
  flows: import_prop_types19.default.arrayOf(import_quake_sdk17.Flow),
  value: import_prop_types19.default.oneOfType([import_prop_types19.default.string, import_prop_types19.default.instanceOf(import_quake_sdk17.Flow), import_prop_types19.default.shape({ id: import_prop_types19.default.string })]),
  onChange: import_prop_types19.default.func,
  allowNull: import_prop_types19.default.bool,
  inputName: import_prop_types19.default.string,
  readOnly: import_prop_types19.default.bool,
  className: import_prop_types19.default.string
};
FlowPicker.defaultProps = {
  allowNull: false,
  readOnly: false,
  inputName: "flow-picker"
};

// src/components/GroupPicker.jsx
var import_react22 = __toESM(require("react"));
var import_prop_types20 = __toESM(require("prop-types"));
var import_quake_sdk18 = require("@quake-saas/quake-sdk");
var GroupPicker = class extends import_react22.default.Component {
  constructor(props2) {
    super(props2);
    this.onChange = this.onChange.bind(this);
    this.state = {};
    this.state.availableGroups = this.props.availableGroups;
    this.state.selectedGroups = this.props.selectedGroups;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.availableGroups != this.props.availableGroups) {
      this.setState({ availableGroups: this.props.availableGroups });
    }
    if (prevProps.selectedGroups != this.props.selectedGroups) {
      this.setState({ selectedGroups: this.props.selectedGroups });
    }
  }
  render() {
    return /* @__PURE__ */ import_react22.default.createElement(Choices, {
      selectMultiple: true,
      onChange: this.onChange,
      allowRemove: true,
      choices: this.state.availableGroups,
      selected: this.state.selectedGroups,
      inputName: this.props.inputName,
      labelField: "name"
    });
  }
  onChange(selection) {
    if (this.props.onChange) {
      this.props.onChange(selection);
    }
  }
};
__publicField(GroupPicker, "propTypes", {
  availableGroups: import_prop_types20.default.arrayOf(import_quake_sdk18.UserGroup),
  selectedGroups: import_prop_types20.default.arrayOf(import_quake_sdk18.UserGroup),
  inputName: import_prop_types20.default.string,
  onChange: import_prop_types20.default.func
});
__publicField(GroupPicker, "defaultProps", {
  inputName: "group-picker",
  availableGroups: [],
  selectedGroups: []
});

// src/components/MessageTemplatePicker.jsx
var import_react23 = __toESM(require("react"));
var import_prop_types21 = __toESM(require("prop-types"));
var import_quake_sdk19 = require("@quake-saas/quake-sdk");
function MessageTemplatePicker({ templates, value, onChange, allowNull, inputName, readOnly }) {
  if (readOnly) {
    return /* @__PURE__ */ import_react23.default.createElement("div", {
      className: "choices"
    }, /* @__PURE__ */ import_react23.default.createElement("div", {
      className: "select custom-select form-control form-control-sm"
    }, /* @__PURE__ */ import_react23.default.createElement("div", {
      className: "choices__list choices__list--single"
    }, /* @__PURE__ */ import_react23.default.createElement("select", {
      hidden: true
    }), /* @__PURE__ */ import_react23.default.createElement("div", {
      className: "choices__item choices__item--selectable"
    }, templates.filter((item) => item.id == value.id)[0]?.name))));
  }
  return /* @__PURE__ */ import_react23.default.createElement(Choices, {
    selectMultiple: false,
    onChange,
    allowRemove: allowNull,
    choices: templates,
    selected: value,
    inputName,
    labelField: "name"
  });
}
MessageTemplatePicker.propTypes = {
  templates: import_prop_types21.default.arrayOf(import_quake_sdk19.MessageTemplate),
  value: import_prop_types21.default.oneOfType([import_prop_types21.default.string, import_prop_types21.default.instanceOf(import_quake_sdk19.MessageTemplate), import_prop_types21.default.shape({ id: import_prop_types21.default.string })]),
  onChange: import_prop_types21.default.func,
  allowNull: import_prop_types21.default.bool,
  inputName: import_prop_types21.default.string,
  readOnly: import_prop_types21.default.bool
};
MessageTemplatePicker.defaultProps = {
  allowNull: false,
  readOnly: false,
  inputName: "flow-picker"
};

// src/components/SearchBox.jsx
var import_prop_types22 = __toESM(require("prop-types"));
var import_react24 = __toESM(require("react"));
var import_uuid2 = require("uuid");
var import_react25 = require("react");
function SearchBox(props2) {
  const [labelId, _setLabelId] = (0, import_react25.useState)((0, import_uuid2.v4)());
  const handleChange = function(event) {
    props2.onChange(event.target.value);
  };
  return /* @__PURE__ */ import_react24.default.createElement("div", {
    className: "input-group input-group-merge input-group-reverse"
  }, /* @__PURE__ */ import_react24.default.createElement("input", {
    className: "form-control",
    autoFocus: !!props2.autoFocus,
    placeholder: props2.placeholder,
    value: props2.value,
    type: "text",
    "aria-label": props2.label,
    "aria-describedby": labelId,
    onChange: handleChange
  }), /* @__PURE__ */ import_react24.default.createElement("div", {
    className: "input-group-text",
    id: labelId
  }, /* @__PURE__ */ import_react24.default.createElement("span", {
    className: "fe fe-search"
  })));
}
SearchBox.propTypes = {
  value: import_prop_types22.default.string,
  label: import_prop_types22.default.string,
  placeholder: import_prop_types22.default.string,
  onChange: import_prop_types22.default.func,
  autoFocus: import_prop_types22.default.bool
};
SearchBox.defaultProps = {
  label: "search",
  placeholder: "search"
};

// src/components/Telephone.jsx
var import_intlTelInput = require("intl-tel-input/build/css/intlTelInput.css");
var import_react26 = __toESM(require("react"));
var import_prop_types23 = __toESM(require("prop-types"));
var import_intl_tel_input = __toESM(require("intl-tel-input"));
var _Telephone = class extends import_react26.default.Component {
  static get DefaultCountry() {
    return "gb";
  }
  static get DefaultCountries() {
    return ["gb", "au", "bb", "be", "bg", "br", "ch", "de", "ee", "es", "fr", "ie", "it", "mk", "nl", "no", "nz", "ro", "pl", "pt", "ua", "us", "za"];
  }
  static get ErrorMap() {
    return {
      0: "Invalid number",
      1: "Invalid country code",
      2: "Too short",
      3: "Too long",
      4: "Invalid number",
      "-99": "Invalid number"
    };
  }
  get classes() {
    return "container q--tel-input " + this.state.classes;
  }
  get inputName() {
    return this.props.inputName || "telInput";
  }
  get label() {
    return void 0 !== this.props.label ? this.props.label : "Telephone";
  }
  get errorMessage() {
    return this.state.errorMessage;
  }
  get allowedCountries() {
    return this.props.allowedCountries || _Telephone.DefaultCountries;
  }
  get initialCountry() {
    return this.props.initialCountry || _Telephone.DefaultCountry;
  }
  get preferredCountries() {
    return this.props.preferredCountries || this.allowedCountries;
  }
  get selectedCountry() {
    return this.iti.getSelectedCountryData().iso2;
  }
  set errorMessage(value) {
    if (this.valid != value && value == null) {
    }
    this.valid = value ? false : true;
    this.setState({ errorMessage: value, valid: this.valid });
  }
  constructor(props2) {
    super(props2);
    this.state = {
      valid: false,
      value: props2.value
    };
    this.initialValue = props2.value;
    this.readOnly = void 0 === props2.readOnly ? false : props2.readOnly;
    this.required = void 0 === props2.required ? true : props2.required;
    this.mobileOnly = void 0 === props2.mobileOnly ? true : props2.mobileOnly;
    this.establishValidNumberTypes();
    this.handleChange = this.handleChange.bind(this);
    this.input = import_react26.default.createRef();
  }
  componentDidMount() {
    this.input.current.addEventListener("countrychange", this.handleChange);
    this.buildIti();
  }
  componentDidUnMount() {
    this.input.current.removeEventListener("countrychange", this.handleChange);
    this.iti.destroy();
  }
  componentDidUpdate() {
    if (this.valid) {
      this.input.current.parentElement.classList.remove("is-invalid");
      this.input.current.parentElement.classList.add("is-valid");
    } else {
      this.input.current.parentElement.classList.remove("is-valid");
      this.input.current.parentElement.classList.add("is-invalid");
    }
  }
  render() {
    return /* @__PURE__ */ import_react26.default.createElement(import_react26.default.Fragment, null, this.label && /* @__PURE__ */ import_react26.default.createElement("label", {
      className: "me-1",
      htmlFor: this.inputName
    }, this.label), /* @__PURE__ */ import_react26.default.createElement("div", null, /* @__PURE__ */ import_react26.default.createElement("input", {
      type: "text",
      className: this.valid ? "form-control form-control-sm is-valid" : "form-control form-control-sm is-invalid",
      ref: this.input,
      name: this.inputName,
      defaultValue: this.state.value,
      readOnly: this.readOnly,
      onChange: this.handleChange
    }), /* @__PURE__ */ import_react26.default.createElement("div", {
      className: "invalid-feedback text-danger"
    }, this.errorMessage)));
  }
  handleChange(_event) {
    this.validate();
    const currentValue = this.iti.getNumber(0);
    if (this.props.onValueValidated && this.valid) {
      this.props.onValueValidated(currentValue || null);
    }
    if (this.props.onValueInvalidated && !this.valid) {
      this.props.onValueInvalidated(currentValue || null);
    }
    this.setState({ value: currentValue });
  }
  validate() {
    const val = this.iti.getNumber();
    if (null != val) {
      if (val == "") {
        if (this.required) {
          this.errorMessage = "Number required";
        } else {
          this.errorMessage = null;
        }
      } else {
        const validNumber = this.iti.isValidNumber();
        let validNumberType = null;
        if (validNumber) {
          validNumberType = this.validNumberType();
        }
        ;
        if (validNumber && validNumberType) {
          this.errorMessage = null;
        } else {
          const errorCode = val.length < 2 ? 2 : this.iti.getValidationError();
          const msg = _Telephone.ErrorMap[errorCode];
          if (typeof msg !== "undefined") {
            this.errorMessage = msg;
          }
        }
      }
    } else {
      this.errorMessage = "Unsupported number type";
    }
  }
  validNumberType() {
    if (this.validNumberTypes == null) {
      return true;
    } else {
      return this.validNumberTypes.includes(this.iti.getNumberType());
    }
  }
  buildIti() {
    this.iti = (0, import_intl_tel_input.default)(this.input.current, {
      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.min.js",
      preferredCountries: this.preferredCountries,
      initialCountry: this.initialCountry,
      onlyCountries: this.allowedCountries
    });
    this.iti.promise.then(this.handleChange.bind(this));
  }
  establishValidNumberTypes() {
    if (this.mobileOnly) {
      this.validNumberTypes = [1, 2];
    } else {
      this.validNumberTypes = null;
    }
  }
};
var Telephone = _Telephone;
__publicField(Telephone, "propTypes", {
  inputName: import_prop_types23.default.string,
  mobileOnly: import_prop_types23.default.bool,
  value: import_prop_types23.default.string,
  label: import_prop_types23.default.string,
  allowedCountries: import_prop_types23.default.arrayOf(import_prop_types23.default.string),
  preferredCountries: import_prop_types23.default.arrayOf(import_prop_types23.default.string),
  initialCountry: import_prop_types23.default.string,
  required: import_prop_types23.default.bool,
  onValueValidated: import_prop_types23.default.func,
  onValueInvalidated: import_prop_types23.default.func,
  readOnly: import_prop_types23.default.bool
});

// src/components/TelephoneWithSubmit.jsx
var import_react27 = __toESM(require("react"));
var import_prop_types24 = __toESM(require("prop-types"));
var TelephoneWithSubmit = class extends import_react27.default.Component {
  constructor(props2) {
    super(props2);
    this.onValueValidated = this.onValueValidated.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onValueInvalidated = this.onValueInvalidated.bind(this);
    this.containerClasses = "mb-3 container " + (props2.containerClasses || "");
    this.buttonClasses = "btn btn-sm " + (props2.buttonClasses || "btn-secondary");
    this.toolTip = {};
    if (this.props.buttonTooltip) {
      this.toolTip["data-bs-toggle"] = "tooltip";
      this.toolTip.title = this.props.buttonTooltip;
    }
    this.buttonRef = import_react27.default.createRef();
  }
  render() {
    if (this.props.tight) {
      return /* @__PURE__ */ import_react27.default.createElement("div", {
        className: this.containerClasses
      }, /* @__PURE__ */ import_react27.default.createElement("div", {
        className: "d-inline-flex align-items-start"
      }, this.input()), /* @__PURE__ */ import_react27.default.createElement("div", {
        className: "d-inline-flex align-items-start"
      }, this.button()));
    } else {
      return /* @__PURE__ */ import_react27.default.createElement("div", {
        className: this.containerClasses
      }, /* @__PURE__ */ import_react27.default.createElement("div", {
        className: "row"
      }, /* @__PURE__ */ import_react27.default.createElement("div", {
        className: "col-8"
      }, this.input()), /* @__PURE__ */ import_react27.default.createElement("div", {
        className: "col-4 d-flex align-items-center"
      }, this.button())));
    }
  }
  button() {
    return /* @__PURE__ */ import_react27.default.createElement("button", {
      type: "button",
      ref: this.buttonRef,
      className: this.buttonClasses,
      onClick: this.handleSubmit,
      ...this.toolTip
    }, this.props.buttonText);
  }
  input() {
    const passThroughs = {
      label: this.props.label,
      inputName: this.props.inputName,
      value: this.props.value,
      mobileOnly: this.props.mobileOnly,
      allowedCountries: this.props.allowedCountries,
      preferredCountries: this.props.preferredCountries,
      initialCountry: this.props.initialCountry
    };
    return /* @__PURE__ */ import_react27.default.createElement(Telephone, {
      inputName: "myTelephoneInput",
      ...passThroughs,
      onValueInvalidated: this.onValueInvalidated,
      onValueValidated: this.onValueValidated
    });
  }
  componentDidMount() {
    this.disableButton();
  }
  onValueValidated(value) {
    this.value = value;
    if (value != this.initialValue) {
      this.enableButton();
    }
  }
  onValueInvalidated(value) {
    this.value = value;
    this.disableButton();
  }
  handleSubmit(_event) {
    if (void 0 != this.props.onButtonClick) {
      this.onButtonClick(this.value);
    }
    ;
  }
  enableButton() {
    this.buttonRef.current.classList.remove("disabled");
    this.buttonRef.current.disabled = false;
  }
  disableButton() {
    this.buttonRef.current.classList.add("disabled");
    this.buttonRef.current.disabled = true;
  }
};
__publicField(TelephoneWithSubmit, "propTypes", {
  inputName: import_prop_types24.default.string,
  mobileOnly: import_prop_types24.default.bool,
  value: import_prop_types24.default.string,
  label: import_prop_types24.default.string,
  allowedCountries: import_prop_types24.default.arrayOf(import_prop_types24.default.string),
  preferredCountries: import_prop_types24.default.arrayOf(import_prop_types24.default.string),
  initialCountry: import_prop_types24.default.string,
  tight: import_prop_types24.default.bool,
  containerClasses: import_prop_types24.default.string,
  buttonClasses: import_prop_types24.default.string,
  buttonTooltip: import_prop_types24.default.string,
  buttonText: import_prop_types24.default.string,
  onButtonClick: import_prop_types24.default.func
});

// src/components/TimeDistancePicker.jsx
var import_react28 = __toESM(require("react"));
function TimeDistancePicker({ seconds, setSeconds, readOnly, min, max, namePrefix, minuteStep }) {
  namePrefix ||= "time-distance";
  if (minuteStep === void 0) {
    minuteStep = 5;
  }
  ;
  if (min === void 0) {
    min = 0;
  }
  const [days, setDays] = (0, import_react28.useState)();
  const [hours, setHours] = (0, import_react28.useState)();
  const [minutes, setMinutes] = (0, import_react28.useState)();
  (0, import_react28.useEffect)(() => {
    if (max && seconds > max) {
      setSeconds(() => max);
    } else if (seconds < min) {
      setSeconds(() => min);
    } else {
      setDays((cur) => {
        return parseInt(seconds / 86400) || 0;
      });
      setHours((cur) => {
        const days2 = parseInt(seconds / 86400) || 0;
        return parseInt((seconds - days2 * 86400) / 3600) || 0;
      });
      setMinutes((cur) => {
        const days2 = parseInt(seconds / 86400) || 0;
        const hours2 = parseInt((seconds - days2 * 86400) / 3600) || 0;
        return parseInt(seconds - days2 * 86400 - hours2 * 3600) / 60 || 0;
      });
    }
  }, [seconds]);
  (0, import_react28.useEffect)(() => {
    if (void 0 !== days && void 0 !== hours && void 0 !== minutes) {
      const proposed = days * 86400 + hours * 3600 + minutes * 60;
      if (seconds != proposed) {
        setSeconds((cur) => cur == proposed ? cur : proposed);
      }
    }
  }, [days, hours, minutes]);
  const onChangeDays = (evt) => {
    evt.preventDefault();
    setDays(evt.target.value);
  };
  const onChangeHours = (evt) => {
    evt.preventDefault();
    setHours(evt.target.value);
  };
  const onChangeMinutes = (evt) => {
    evt.preventDefault();
    setMinutes(evt.target.value);
  };
  const isValid = !!seconds && (min === void 0 || seconds >= min) && (max === void 0 || seconds <= max);
  if (void 0 === days || void 0 === hours || void 0 === minutes) {
    return /* @__PURE__ */ import_react28.default.createElement(import_react28.default.Fragment, null);
  }
  return /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "row"
  }, /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "col-2"
  }, /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "d-inline"
  }, /* @__PURE__ */ import_react28.default.createElement("input", {
    type: "number",
    name: `${namePrefix}-days`,
    value: days,
    onChange: onChangeDays,
    required: true,
    disabled: readOnly,
    className: `form-control form-control-sm ${isValid ? "is-valid" : "is-invalid"}`,
    min: 0
  })), days == 1 ? "Day" : "Days"), /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "col-2"
  }, /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "d-inline"
  }, /* @__PURE__ */ import_react28.default.createElement("input", {
    type: "number",
    name: "flow-max-time-hours",
    value: hours,
    onChange: onChangeHours,
    required: true,
    disabled: readOnly,
    className: `form-control form-control-sm ${isValid ? "is-valid" : "is-invalid"}`,
    min: -1,
    max: 24
  })), hours == 1 ? "Hour" : "Hours"), /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "col-2"
  }, /* @__PURE__ */ import_react28.default.createElement("div", {
    className: "d-inline"
  }, /* @__PURE__ */ import_react28.default.createElement("input", {
    type: "number",
    name: "flow-max-time-days",
    value: minutes,
    onChange: onChangeMinutes,
    required: true,
    disabled: readOnly,
    className: `form-control form-control-sm ${isValid ? "is-valid" : "is-invalid"}`,
    min: minuteStep * -1,
    max: 60,
    step: minuteStep
  })), minutes == 1 ? "Minute" : "Minutes"));
}

// src/main.js
module.exports = {
  Choices,
  EmailAddress,
  EntityAndValueBadge,
  EntityAndValuePicker,
  EntityAndValueTag,
  EntityPicker,
  EntityValue,
  FlowPicker,
  GroupPicker,
  MessageTemplatePicker,
  SearchBox,
  Telephone,
  TelephoneWithSubmit,
  TimeDistancePicker
};
//# sourceMappingURL=bundle.js.map
